
import { required, minLength, maxLength, email, numeric } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { metaDataMixin } from '~/mixins'

export default {
  mixins: [
    validationMixin,
    metaDataMixin,
  ],
  asyncData ({ store, route }) {
    store.dispatch('breadcrumbs/set', {
      path: route.fullPath,
      width: 6,
      items: [
        {
          to: '/contact',
          label: 'Contact',
        },
        {
          label: 'Vraag stellen',
        },
      ],
    })
  },
  data () {
    return {
      inputDescription: null,
      inputRelationNumber: null,
      inputName: null,
      inputEmail: null,
      inputPhone: null,
      errorMessages: {
        inputDescription: ['laat ons weten waar we bij kunnen helpen.'],
        inputRelationNumber: ['vul een correct relatienummer in of laat het leeg.'],
        inputEmail: ['vul een correct e-mailadres in.'],
        inputName: ['naam is een verplicht veld.'],
        inputPhone: ['vul een correct telefoonnummer in.'],
      },
      seo: {
        title: 'Vraag stellen',
        description: 'Stel je vraag door het formulier in te vullen en op te sturen.',
      },
    }
  },
  validations: {
    inputDescription: {
      required,
      minLength: minLength(2),
    },
    inputRelationNumber: {
      numeric,
      minLength: minLength(9),
      maxLength: maxLength(9),
    },
    inputName: {
      required,
      minLength: minLength(2),
    },
    inputEmail: {
      required,
      email,
    },
    inputPhone: {
      // Dutch phone number regex from https://regexr.com/3aevr
      validPhone:
        value => /^((\+|00(\s|\s?-\s?)?)31(\s|\s?-\s?)?(\(0\)[-\s]?)?|0)[1-9]((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/.test(value) ||
        value === null ||
        value === '',
    },
  },
}
